import * as React from "react";

import { FormControl, Grid, MenuItem, Select, Stack, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery } from "@mui/material";

import TableChartIcon from "@mui/icons-material/TableChart";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import PieChartIcon from "@mui/icons-material/PieChart";

import ExaminationViewChart from "./ExaminationViewChart.jsx";
import ExaminationViewTable from "./ExaminationViewTable.jsx";
import PlaqueAndBleedingChart from "./PlaqueAndBleedingChart.jsx";

import { getPatientDisplayName } from "../../../../helper-functions/shared/patientDisplay.js";

/**
 * The charts and statistics a saved examination shows, rendered from the practice draft.
 */
export default function PracticeResults(props) {
    const { teethData, summaryData, patient, openAppDrawer = false } = props;
    const isMobile = useMediaQuery("@media (max-width:630px)");
    const [viewMode, setViewMode] = React.useState("chart");

    const patientInfo = {
        name: getPatientDisplayName(patient),
        date: "Practice, not saved",
        patient
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ px: 2, pt: 1 }}>
                    These are the same charts and statistics a saved examination shows. Nothing was written to the patient records.
                </Typography>
                <Stack direction="row" spacing={1} useFlexGap alignItems="center" justifyContent="center" sx={{ flexWrap: "wrap", width: "100%", mt: 1 }}>
                    {isMobile ? (
                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <Select value={viewMode} onChange={(event) => setViewMode(event.target.value)}>
                                <MenuItem value="table">Table View</MenuItem>
                                <MenuItem value="chart">Chart View</MenuItem>
                                <MenuItem value="pdbop">PI/BOP/PD</MenuItem>
                            </Select>
                        </FormControl>
                    ) : (
                        <ToggleButtonGroup
                            value={viewMode}
                            exclusive
                            onChange={(event, nextMode) => nextMode && setViewMode(nextMode)}
                            size="small"
                            color="primary">
                            <ToggleButton value="table">
                                <TableChartIcon sx={{ mr: 0.5 }} />
                                Table View
                            </ToggleButton>
                            <ToggleButton value="chart">
                                <InsertChartIcon sx={{ mr: 0.5 }} />
                                Chart View
                            </ToggleButton>
                            <ToggleButton value="pdbop">
                                <PieChartIcon sx={{ mr: 0.5 }} />
                                PI/BOP/PD
                            </ToggleButton>
                        </ToggleButtonGroup>
                    )}
                </Stack>
            </Grid>

            {viewMode === "table" && (
                <Grid container item xs={12}>
                    <ExaminationViewTable teethData={teethData} summaryData={summaryData} patientInfo={patientInfo} openAppDrawer={openAppDrawer} />
                </Grid>
            )}

            {viewMode === "chart" && (
                <Grid item xs={12}>
                    <ExaminationViewChart teethData={teethData} summaryData={summaryData} patientInfo={patientInfo} openAppDrawer={openAppDrawer} />
                </Grid>
            )}

            {viewMode === "pdbop" && (
                <Grid item xs={12}>
                    <PlaqueAndBleedingChart teethData={teethData} patientInfo={patientInfo} />
                </Grid>
            )}
        </Grid>
    );
}
